import { inject }        from '@angular/core';
import { CanActivateFn } from '@angular/router';
import {
  map,
  take,
}                        from 'rxjs';
import { RbAuthService } from '../core';

export const loggedInGuard: CanActivateFn = (_route, state) => {
  const rbAuthService = inject(RbAuthService);

  return rbAuthService.isAuthenticated$.pipe(
    take(1),
    map(isAuthenticated => {
      if (isAuthenticated) {
        return true;
      }
      rbAuthService.login(state.url, true);
      return false;
    }),
  );
};
